import { canonicalizeDomain } from "@/utils/domain";

export const normalizeBrandKey = (value?: string | null) =>
  String(value || "").trim().toLowerCase();

export const normalizeAliasKey = (value?: string | null) =>
  String(value || "")
    .toLowerCase()
    .replace(/\([^)]*\)/g, " ")
    .replace(/[^a-z0-9.]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const isDomainLikeAlias = (value?: string | null): boolean =>
  Boolean(value && /^[a-z0-9-]+(?:\.[a-z0-9-]+)+$/i.test(value));

export const isDomainLikeValue = (value?: string | null): boolean =>
  isDomainLikeAlias(canonicalizeDomain(value || "") || "");

export const buildBrandKeyVariants = (value?: string | null) => {
  const variants = new Set<string>();
  const normalized = normalizeBrandKey(value);
  if (normalized) {
    variants.add(normalized);
  }

  const domain = canonicalizeDomain(value || "");
  const domainLike = isDomainLikeAlias(domain || "");
  const alias = normalizeAliasKey(value);
  if (alias) {
    variants.add(alias);
    variants.add(alias.replace(/\s+/g, ""));
    if (!domainLike) {
      const firstToken = alias.split(" ")[0];
      if (firstToken) {
        variants.add(firstToken);
      }
    }
  }

  if (domain && domainLike) {
    variants.add(normalizeBrandKey(domain));
  }

  return Array.from(variants).filter(Boolean);
};
